import BaseViewController from "./base-view-controller";

class AdvanceMedicalAddDependentConfirmationViewController extends BaseViewController {
  preprocessScreenData() {
    this.appData.history[0].formState = this.appData.history[1].formState;
  }
}

export default AdvanceMedicalAddDependentConfirmationViewController;
